import { ProcessSelectionActionType, ProcessSelectionConfiguration } from '@sdbn/tmc-common';
import { MatDialog } from '@angular/material/dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { ProcessSelectOption } from '@sdbn/tmc-common';
import { VisitorType } from '../tmc-visit.model';
import { AppServerAPI } from '@sdbn/common';

export class VisitorTypeSelectionController extends AbstractStepController {

  private dialogService: DialogService;
  private appServerAPI: AppServerAPI;

  selectOptions = new Array<ProcessSelectOption>();

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
    if (contextChange.key === 'selectedProcessOption' && contextChange.value != null) {
      this.handleSelectedProcessOption(this.dashboardContext.getContextValue('selectedProcessOption'));
    }
  }

  onRegisterToDashboardContext() {
    this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
    this.dashboardContext.setContextValue('selectedProcessOption', null);
    this.dashboardContext.setContextValue('dashboardConfiguration', null);
    this.buildAndApplySelectionModelToContext();
  }


  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('visitor type selection started');

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    const matDialog = WizardServiceLocator.injector.get(MatDialog);

    this.dialogService.showConfirm(
      'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message'
    ).afterClosed().subscribe(() => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.restartWizard();
    });

  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    return controls;
  }

  private handleSelectedProcessOption(selectedProcessOption: ProcessSelectOption) {
    this.wizardComponent.stopInactivityMonitoring();
    this.dashboardContext.setContextValue('visitorType', selectedProcessOption.key);
    if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_FLOW) {
      this.wizardComponent.handoverToFlow(selectedProcessOption.processFlowKey);
    } else if (selectedProcessOption.actionType === ProcessSelectionActionType.PROCESS_STEP) {
      this.wizardComponent.next(selectedProcessOption.processStepKey);
    } else {
      console.error('Invalid ProcessSelectionActionType' + selectedProcessOption.actionType);
    }
  }

  private buildAndApplySelectionModelToContext() {

    this.appServerAPI.execute<VisitorType[]>('/terminal/registration/visitor/find-visitor-roles', {}).subscribe(result => {
      if (result != null) {
        for (const entry of result) {
          const visitorType = new VisitorType(entry);

          const option = new ProcessSelectOption({
            key: visitorType.id,
            titleDictionaryEntry: visitorType.name,
            titleIconCss: visitorType.icon,
            descriptionDictionaryKey: '',
            processStepKey: this.getNextProcessStepByRoleMapping(entry.externalKey),
            actionType: ProcessSelectionActionType.PROCESS_STEP
          });
          this.selectOptions.push(option);

          if (visitorType.id === this.dashboardContext.getContextValue('visitorType')
            && this.wizardComponent.currentStep.dashboardConfiguration?.autoselect === true) {
            this.dashboardContext.setContextValue('selectedProcessOption', option);
            return;
          }
        }
      }
      this.dashboardContext.setContextValue('dashboardConfiguration',
        new ProcessSelectionConfiguration({ selectOptions: this.selectOptions }));
    }, error => {
      console.error('Failed to find visitor roles', error);
    });

  }

  private getNextProcessStepByRoleMapping(externalKey: string) {
    const mapping = this.wizardComponent.currentStep.dashboardConfiguration?.roleToProcessStepMapping;
    if (externalKey == null || externalKey.trim().length === 0 || mapping[externalKey] == null) {
      const defaultConfig = this.wizardComponent.currentStep.dashboardConfiguration?.roleDefaultProcessStep;
      const defaultProcessingStepKey = defaultConfig?.default;

      if (defaultProcessingStepKey == null) {
        console.error('roleDefaultProcessStep not found for VisitorRole external Key' + externalKey);
      }

      return defaultProcessingStepKey;
    }
    return mapping[externalKey];
  }

}
